const styles = {
  container: {
    flexDirection: "column" as "column",
    flex: 1,
  },

  inputFieldContainer: {
    flexDirection: "row" as "row",
    alignItems: "center",

    backgroundColor: "#ffffff",
  },

  inputFieldBottomLine: {
    borderBottomColor: "#e8e8e8",
    borderBottomWidth: 1,
  },

  defaultMarginBottom: {
    // marginBottom: 10,
  },

  inner: {
    position: "relative" as "relative",
    display: "flex",
    flex: 1,
    flexDirection: "row" as "row",
    paddingHorizontal: 3,
    paddingVertical: 0,
    height: "100%",
  },

  unitContainer: {
    paddingLeft: 1,
    marginTop: 2,
    marginRight: "20px",
    marginBottom: 2,
    display: "flex",
  },

  unitText: {
    textAlignVertical: "center",
    color: "black",
  },

  inputField: {
    width: "100%",
    flex: 1,

    margin: 0,

    fontSize: "0.938rem", //15px

    alignSelf: "center",
    color: "black",
  },

  inputFieldBorder: {
    border: "1px solid #E8E8E8",
  },

  inputFieldFocused: {
    borderBottomColor: "black",
  },

  inputFieldFocusedBordered: {
    borderColor: "black",
  },

  submitButtonContainer: {
    minWidth: 105,
    paddingLeft: 5,
  },

  submitButton: {
    // position: 'absolute',
    top: 10,
    paddingTop: 5,
    paddingBottom: 5,
    right: 0,
    minWidth: 105,
  },

  descriptionText: {
    fontSize: 14,
    // lineHeight: 12,
    color: "black",
  },

  leftIcon: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    justifyContent: "center",
  },

  rightIcon: {
    top: 0,
    bottom: 0,
    right: 0,
    position: "absolute",
    justifyContent: "center",
  },
};

export default styles;
